module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/cx-zero-logo-e10d1e974c1344233b4acaea8678745f.svg";